import { useCallback, useEffect, useState } from 'react';

import { PricingTablePlan } from '../types';

const useSiblingsList = (list: PricingTablePlan[]) => {
  const { siblings, noSiblings } = list.reduce(
    (acc, plan) => {
      !!plan.sibling ? acc.siblings.push(plan) : acc.noSiblings.push(plan);
      return acc;
    },
    { siblings: [] as (PricingTablePlan | undefined)[], noSiblings: [] as PricingTablePlan[] }
  );

  const [currentSiblingId, setCurrentSiblingId] = useState(siblings[0]?.id);
  const getList = () =>
    [...noSiblings, siblings.find(sibling => sibling?.id === currentSiblingId) as PricingTablePlan].filter(Boolean);

  const [localList, setLocalList] = useState(getList());

  const changeSibling = useCallback(
    (newSibling: PricingTablePlan) => {
      setLocalList([...noSiblings, newSibling]);
      newSibling.id;
      setCurrentSiblingId(newSibling.id);
    },
    [noSiblings]
  );

  useEffect(() => {
    const newList = getList();
    JSON.stringify(newList) !== JSON.stringify(localList) && setLocalList(newList);
  }, [list]);

  return [
    { localList, siblings: siblings.length ? (siblings as PricingTablePlan[]) : undefined },
    { changeSibling }
  ] as const;
};

export default useSiblingsList;
